import React from 'react'

export default ({ text }) => {
	return (
		<div className="quote">
			<p>{text.join(', ')}</p>
		</div>
	)
}